import { QueryClient } from '@tanstack/vue-query'

const sharedConfig = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: import.meta.env.PROD
      }
    }
  }
}

const queryClient = new QueryClient(sharedConfig.queryClientConfig)

export { sharedConfig, queryClient }
